export const formatTelefone = (number) => {
  const result =
    number.toString().length === 9
      ? number.toString().slice(0, 5) + "-" + number.toString().slice(5, 10)
      : number.toString().slice(0, 4) + "-" + number.toString().slice(4, 9);

  return result;
};
